import React from "react"
import { CheckCircle2 } from "lucide-react"

interface SuccessStateProps {
  onReset: () => void
}

export const SuccessState: React.FC<SuccessStateProps> = ({ onReset }) => (
  <div className="bg-[#1e1e1e]/90 backdrop-blur-md border border-emerald-500/30 rounded-2xl p-10 text-center">
    <div className="w-16 h-16 bg-emerald-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
      <CheckCircle2 className="w-8 h-8 text-emerald-400" />
    </div>
    <h3 className="text-xl font-bold text-white mb-2">Registration Submitted!</h3>
    <p className="text-neutral-400 text-sm mb-6">
      Thank you, your farm has been successfully registered in the national tree inventory.
    </p>
    <button
      onClick={onReset}
      className="px-5 py-2.5 bg-emerald-500 hover:bg-emerald-400 text-black text-sm font-bold rounded-lg transition-colors"
    >
      Register Another Farmer
    </button>
  </div>
)